import Util from '@/util';
/* eslint-disable import/no-cycle */
import Api from '@/api';
/* eslint-enable import/no-cycle */

const theState = {
    query: '',
    items: [],
    rules: [
        v => !!v || 'Der Suchbegriff darf nicht leer sein.',
    ],
    errorMessage: '',
    loading: false,
};

const actions = {
    search({ commit }, { query }) {
        commit('setLoading', true);
        commit('setQuery', query);
        commit('setItems', []);
        commit('setErrorMessage', '');
        Api.search.salesforceSearch(query)
            .then(({ data }) => {
                commit('setItems', data.data);
            }).catch(() => {
                commit('setErrorMessage', 'Bei der Suche ist ein Fehler aufgetreten.');
            }).finally(() => {
                commit('setLoading', false);
            });
    },
};

const mutations = {
    setQuery(state, query) {
        state.query = query;
    },

    setLoading(state, loading) {
        state.loading = loading;
    },

    setErrorMessage(state, errorMessage) {
        state.errorMessage = errorMessage;
    },

    setItems(state, items) {
        state.items = items;
    },
};

const getters = {
    /*
     * raw data example:
     * {
     *   FirstName: "Johann"
     *   Id: "0011x00000SxA7QAAV"
     *   LastName: "Prenzler"
     *   PersonBirthdate: "2019-10-01"
     *   PersonEmail: "johann.prenzler@mhn-digital.de"
     *   SAP_GP_Nummer__c: null
     *   SSO_ID__c: "5b18803e-b1a9-4565-95b9-308a834ee0ee"
     *   Salutation: "Herr"
     *   attributes: {
     *     type: "Account"
     *     url: "/services/data/v47.0/sobjects/Account/0011x00000SxA7QAAV"
     *   }
     * }
     */
    result(state) {
        return state.items.map((item, key) => ({
            id: key,
            name: Util.salesforceDataToFullname(item),
            email: item.PersonEmail || '-',
            ssoId: item.SSO_ID__c || '-',
            existInC1: !!item.SSO_ID__c,
            existInSap: !!item.SAP_GP_Nummer__c,
            hatWerbesperre: !!item.Status__c && item.Status__c === 'Inaktiv - globale Werbesperre',
            sfId: item.Id,
            gpNumber: item.SAP_GP_Nummer__c || '-',
            birthdate: Util.toDate(item.PersonBirthdate) || '-',
        }));
    },

    resultFor(state) {
        if (state.query.length) {
            return `Suchergebnisse für "${state.query}"`;
        }
        return '';
    },
};

export default {
    namespaced: true,
    state: theState,
    actions,
    mutations,
    getters,
};
